export const transformPhotosData = (data) => {
    const newArray = [];
    data.map(photo => {
        newArray.push({ src: photo.imgUrl });
    })
    return newArray;
}